import { render, staticRenderFns } from "./doubleLine.vue?vue&type=template&id=48e6fc23&scoped=true&"
import script from "./doubleLine.vue?vue&type=script&lang=js&"
export * from "./doubleLine.vue?vue&type=script&lang=js&"
import style0 from "./doubleLine.vue?vue&type=style&index=0&id=48e6fc23&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e6fc23",
  null
  
)

export default component.exports